export class Area {
	company: number;
	location: any;
	id: number;
	name: string;
}

export class AdminAreaRequest {
	name:string;
	warehouse?:number;
}